import { getDynamicMeta } from "../general_functions";
import { getImageByContentId } from "../images";

//import stepguide from "../../templates/modules/stepguide";
//import services from "../../templates/modules/services";
import { campaignsFront } from "../../templates/modules/campaigns";
import { newslistFront } from "../../templates/modules/newslist";
import { buttonRowFront } from "../../templates/modules/buttonrow";
import { renholdFront } from "../../templates/modules/renhold";
import { heroFront, heroFront2 } from "../../templates/modules/hero";
import { projectsFront } from "../../templates/modules/projects";
import { cardsFront } from "../../templates/modules/cardlisting";
import { alertsFront } from "../../templates/modules/alerts";
//import { warningsFront } from "../../templates/modules/warnings";
//import { testimonial, testimonialContainer } from "../../templates/modules/testimonial";
//import check_adress from "../../templates/forms/check_adress";
//import contact from "../../templates/forms/contact";

export const compile_content = (orgHtml, data) => {
    let html = $("<div>" + orgHtml + "</div>");
    let includedRelatedContent = data.relatedContentObjects;
    // console.log("test x");
    html.find(".h-card").unwrap();
    // html.find("span#editorBlokk").parent("p").unwrap();

    html.find("span#editorBlokk > span").each(function() {
        var id = $(this).attr("id") || false;
        var that = $(this);
        if (id) {
            $.each(includedRelatedContent, function(nr, obj) {
                if (obj.contentId === id) {
                    var html = $(`<div class="blokk" data-id="${obj.contentId}" data-author="${obj.creator}"></div>`);
                    if (obj.pageTypeId === "mal_blokk") {
                        if (obj.contentId === "dbab27c4-7c5d-4ef4-a6c7-941bbc62e85e") {
                            // Forced template;
                            let tContainer = testimonialContainer(obj);
                            // console.log("Forced");
                            html.append(tContainer);
                        }
                        else {
                            html.append(decodeURIComponent(obj.contentObject));
                        }
                    }
                    else if (obj.pageTypeId === "mal_dynamisk") {
                        let dynamicMeta = JSON.parse(decodeURIComponent(obj.metaObject));

                        if (dynamicMeta.id === "17c15981-758d-4d09-a7ee-b2d47d2af6f0" || dynamicMeta.contentTypeId === "17c15981-758d-4d09-a7ee-b2d47d2af6f0") {
                            let topimageHtml = heroFront2(obj);
                            html.append(topimageHtml);
                        }
                        else if (dynamicMeta.id === "cd3957ad-61cc-4580-a458-e62039fb4bad" || dynamicMeta.contentTypeId === "cd3957ad-61cc-4580-a458-e62039fb4bad") {
                            // let ref = testimonial(dynamicMeta, obj);
                            // html.append(ref);
                        }
                        else if (dynamicMeta.id === "6d0c6d38-e11d-4606-8550-d3ca77ae1ca0" || dynamicMeta.contentTypeId === "6d0c6d38-e11d-4606-8550-d3ca77ae1ca0") {
                            let service = services(obj, dynamicMeta);
                            html.append(service)
                        }
                        else {
                            console.warn("no template", dynamicMeta);
                        }
                    }

                    if (obj.relatedContentObjects) {
                        if (obj.relatedContentObjects.length > 0) {
                            // console.log(html.prop("outerHTML"));
                            let children = compile_content(html.prop("outerHTML"), obj);
                            // console.log(children);
                            html = children;
                        }
                    }
                    that.parent().replaceWith(html);
                }
            });

            let working = includedRelatedContent.filter((obj) => {
                return (obj.contentId === id ? obj : false)
            });
        }
    });

    html.find("a[href*='aim:']").each(function() {
        $(this).attr("href", $(this).attr("href").replace("aim:", "/artikkel/"));
    })
    // console.log("before change", html);
    html = html.prop("outerHTML");
    if (html.match(/\[split:(.|\n)*\]/gmi)) {
        // console.log("has split");
        html.match(/\[split:(.|\n)*\]/gmi).forEach(me => {
            //   console.log(me);
            let split = me.replace("[split:</p>", "").replace("<p>]", "");
            // console.log(split);
            if (split.match("<p>||</p>")) {
                split = split.split(/<p>\|\|<\/p>/gmi);
                // console.log("splitting?",split);
                if (split.length > 1) {
                    let cols = [];
                    split.forEach(col => {
                        cols.push(`
                        <div class="col">
                            ${col}
                        </div>
                        `);
                    });

                    cols = cols.join("");

                    let row = `
                    <div class="row row-eq-height">
                        ${cols}
                    </div>`;

                    html = html.replace(me, row);
                }
            }
        });
    }

    if (html.match(/\[modul:.+?\]/gmi)) {
        html.match(/\[modul:.+?\]/gmi).forEach((me) => {
            let modulename = me.replace("[modul:", "").replace("]", "");
            let moduleHtml = ``;
            let maxItems = ``;
            //   console.log(modulename);
            if (modulename === "stepguide") {
                moduleHtml = stepguide;
            }
            else if (modulename.match("nyhetliste")) {
                let moduleParams = modulename.replace("nyhetliste:", "").split(':');
                maxItems = moduleParams[0];
                let moduleTitle = moduleParams[1];
                let moduleCardDesign = moduleParams[2]?moduleParams[2]:"";
                moduleHtml = newslistFront(maxItems, moduleTitle, moduleCardDesign);
            }
            else if (modulename.match("kampanje")) {
                let moduleParams = modulename.replace("kampanje:", "").split(':');
                maxItems = moduleParams[0];
                let moduleCardItemGuid = moduleParams[1]?moduleParams[1]:"";
                let moduleCardDesign = moduleParams[2]?moduleParams[2]:"";
                moduleHtml = campaignsFront(maxItems, moduleCardItemGuid, moduleCardDesign);
            }
            else if (modulename.match("txest")) {
                //let moduleParams = modulename.replace("test", "");
                let params = JSON.parse(modulename.replace("test", ""))
                moduleHtml = heroFront2(params);
            }
            else if (modulename.match("prosjektliste")) {
                let moduleParams = modulename.replace("prosjektliste:", "");
                maxItems = moduleParams.slice(0, moduleParams.indexOf(":"));
                let moduleTitle = moduleParams.slice(moduleParams.indexOf(":") + 1);
                moduleHtml = projectsFront(maxItems, moduleTitle);
            }
            else if (modulename.match("cardlist")) {
                let moduleParams = modulename.replace("cardlist:", "").split(':');
                maxItems = moduleParams[0];
                let moduleCategory = moduleParams[1];
                let moduleTitle = moduleParams[2];
                let moduleCardDesign = moduleParams[3]?moduleParams[3]:"";
                let moduleMoreText = moduleParams[4]?moduleParams[4]:"";
                let moduleMoreLink = moduleParams[5]?moduleParams[5]:"";
                moduleHtml = cardsFront(moduleCategory, maxItems, moduleTitle, moduleMoreText, moduleMoreLink, moduleCardDesign);
            }
            else if (modulename.match("skjema")) {
                let skjema = "kontakt";
                if (modulename.match(":")) {
                    let splitM = modulename.split(":");
                    // console.log(modulename)
                    skjema = splitM[1];
                }
                // console.log(skjema);
                if (skjema === "bestilling") {
                    moduleHtml = check_adress;
                }
                else if (skjema === "kontakt") {
                    // console.log("contact", contact());
                    moduleHtml = contact();
                }
            }
            else if (modulename.match("beredskapsmelding")) {
                moduleHtml = warningsFront();
            }
            else if (modulename.match("knapperad")) {
                let moduleParams = modulename.replace("knapperad:", "").split(':');
                let buttons = moduleParams[0];
                let moduleButtonRowDesign = moduleParams[1]?moduleParams[1]:"";
                moduleHtml = buttonRowFront(buttons, moduleButtonRowDesign);
            }
            else if (modulename.match("some")) {
                let some = modulename.replace("some:", "");
                let someType = some.slice(0, some.indexOf(":"));
                let someLink = some.slice(some.indexOf(":") + 1);
                moduleHtml = `<div class="some"><a href="${someLink}"><img src="/images/some/${someType}.svg" alt="${someType}"></img></a></div>`;
            }
            else if (modulename.match("renhold")) {
                let kommuneNr = modulename.replace("renhold:", "");
                moduleHtml = renholdFront(kommuneNr);
            }
            else if (modulename.match("hero")) {
                let moduleParams = modulename.replace("hero:", "").split(':');
                let splash = moduleParams[0];
                let moduleHeroDesign = moduleParams[1]?moduleParams[1]:"";
                let moduleHeroText = moduleParams[2]?moduleParams[2]:""
                moduleHtml = heroFront(splash, moduleHeroDesign, moduleHeroText);
            }
             else if (modulename.match("alerts")) {
                let moduleParams = modulename.replace("alerts:", "").split(':');
                let moduleAlertsDesign = moduleParams[0]?moduleParams[0]:"";
                moduleHtml = alertsFront(moduleAlertsDesign);
            }
            else {
                moduleHtml = "";
                console.warn("no module", modulename);
            }
            //   console.log(me, moduleHtml);
            html = html.replace(me, moduleHtml);
        });
    }
    // console.log(html);
    return html;
}
